export const environment = {
  production: true,
  apiURL: "http://46.137.105.149:8070",
  portalType: 'main-portal'
};
